import { Controller } from "stimulus";

export default class extends Controller {
  connect() {}

  toggle(e) {
    e.preventDefault();
    this.element.classList.toggle("show-chart");
    document.body.classList.toggle("overflow-hidden-below-desktop");
  }
}
